export default __webpack_public_path__ + "static/media/ic-event-note.c90dc472.svg";